import config_ from './config.json';

type configKey =
	| 'amdnet'
	| 'carl-remigius'
	| 'charlotte-fresenius-uni'
	| 'charlotte-fresenius-uni.at'
	| 'hs-fresenius'
	| 'oncampus'
	| 'fernstudium-fresenius'
	| 'studyplus'
	| 'lunex-university'
	| 'bzgk'
	| 'ecosign'
	| 'uos'
	| 'ecosign-institut'
	| 'crf-education'
	| 'pioneerlab';

interface SiteConfig {
	domain: string;
	extraDomains: string[];
}

// each key in config.json corresponds to a directory that is then imported for the listed domains
export const config: { [ key in configKey ]: SiteConfig } = config_;

export const isUniversityActive = ( key: configKey, domains: string[] ) => {
	const { hostname } = window.location;

	return (
		domains.includes( hostname ) ||
		// we need DEV_UNIVERSITY to choose the correct implementation on localhost
		( hostname === 'localhost' && process.env.DEV_UNIVERSITY === key )
	);
};

export const loadGtmEvents = async () => {
	for ( const entry of Object.entries( config ) ) {
		const [ key, site ] = entry;
		const domains = [ site.domain, ...site.extraDomains ];
		if ( isUniversityActive( key as configKey, domains ) ) {
			try {
				await import(
					/* webpackChunkName: "tracking-events-[request]" */
					'@src/scripts/gtm/' + key
				);
			} catch ( error ) {
				// eslint-disable-next-line no-console
				console.error(
					`Failed to load GTM events for key: ${ key }`,
					error
				);
			}
		}
	}
};

export const getSiteConfig = () => {
	const pair = Object.entries( config ).find( ( [ key, site ] ) => {
		const domains = [ site.domain, ...site.extraDomains ];
		return isUniversityActive( key as configKey, domains );
	} );

	return pair && pair[ 1 ];
};

type EventsTable = {
	columnNames: string[];
	rows: string[][];
};

export const getEventsTable = async (): Promise< EventsTable > => {
	return await import( '@src/data/events-table.json' );
};
